import "core-js/modules/es.array.reverse.js";
var _class, _ArcGisFeatureServerCatalogItem;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { featureCollection } from "@turf/helpers";
import i18next from "i18next";
import { computed, makeObservable, override, runInAction } from "mobx";
import WebMercatorTilingScheme from "terriajs-cesium/Source/Core/WebMercatorTilingScheme";
import URI from "urijs";
import isDefined from "../../../Core/isDefined";
import loadJson from "../../../Core/loadJson";
import Result from "../../../Core/Result";
import { networkRequestError } from "../../../Core/TerriaError";
import ProtomapsImageryProvider from "../../../Map/ImageryProvider/ProtomapsImageryProvider";
import featureDataToGeoJson from "../../../Map/PickedFeatures/featureDataToGeoJson";
import { ProtomapsArcGisPbfSource } from "../../../Map/Vector/Protomaps/ProtomapsArcGisPbfSource";
import { tableStyleToProtomaps } from "../../../Map/Vector/Protomaps/tableStyleToProtomaps";
import GeoJsonMixin from "../../../ModelMixins/GeojsonMixin";
import MinMaxLevelMixin from "../../../ModelMixins/MinMaxLevelMixin";
import ArcGisFeatureServerCatalogItemTraits from "../../../Traits/TraitsClasses/ArcGisFeatureServerCatalogItemTraits";
import CreateModel from "../../Definition/CreateModel";
import proxyCatalogItemUrl from "../proxyCatalogItemUrl";
import { ArcGisFeatureServerStratum } from "./ArcGisFeatureServerStratum";
let ArcGisFeatureServerCatalogItem = (_class = (_ArcGisFeatureServerCatalogItem = class ArcGisFeatureServerCatalogItem extends MinMaxLevelMixin(GeoJsonMixin(CreateModel(ArcGisFeatureServerCatalogItemTraits))) {
  constructor() {
    super(...arguments);
    makeObservable(this);
  }
  get type() {
    return ArcGisFeatureServerCatalogItem.type;
  }
  get typeName() {
    return i18next.t("models.arcGisFeatureServerCatalogItem.name");
  }
  async forceLoadMetadata() {
    if (this.strata.get(ArcGisFeatureServerStratum.stratumName) === undefined) {
      const stratum = await ArcGisFeatureServerStratum.load(this);
      runInAction(() => {
        this.strata.set(ArcGisFeatureServerStratum.stratumName, stratum);
      });
    }
  }
  async forceLoadGeojsonData() {
    var _featureDataToGeoJson2;
    // If we are tiling requests, then we use the ProtomapsImageryProvider - see mapItems
    if (this.tileRequests) return featureCollection([]);
    const getEsriLayerJson = async resultOffset => {
      const url = proxyCatalogItemUrl(this, this.buildEsriJsonUrl(resultOffset).throwIfUndefined().toString());
      return await loadJson(url);
    };
    if (!this.supportsPagination) {
      var _featureDataToGeoJson;
      // Make a single request without pagination
      return (_featureDataToGeoJson = featureDataToGeoJson(await getEsriLayerJson())) !== null && _featureDataToGeoJson !== void 0 ? _featureDataToGeoJson : {
        type: "FeatureCollection",
        features: []
      };
    }

    // Esri Feature Servers have a maximum limit to how many features they'll return at once, so for a service with many
    // features, we have to make multiple requests. We can't figure out how many features we need to request ahead of
    // time (there's an API for it but it times out for services with thousands of features), so we just keep trying
    // until we run out of features or hit the limit
    const featuresPerRequest = this.featuresPerRequest;
    const maxFeatures = this.maxFeatures;
    const combinedEsriLayerJson = await getEsriLayerJson(0);
    const mapObjectIds = features => features.map(feature => {
      var _feature$attributes$O;
      return (_feature$attributes$O = feature.attributes.OBJECTID) !== null && _feature$attributes$O !== void 0 ? _feature$attributes$O : feature.attributes.objectid;
    });
    const seenIDs = new Set(mapObjectIds(combinedEsriLayerJson.features));
    let currentOffset = 0;
    let exceededTransferLimit = combinedEsriLayerJson.exceededTransferLimit;
    while (combinedEsriLayerJson.features.length <= maxFeatures && exceededTransferLimit === true) {
      currentOffset += featuresPerRequest;
      const newEsriLayerJson = await getEsriLayerJson(currentOffset);
      if (newEsriLayerJson.features === undefined || newEsriLayerJson.features.length === 0) {
        break;
      }
      const newIds = mapObjectIds(newEsriLayerJson.features);
      if (newIds.every(id => seenIDs.has(id))) {
        // We're getting data that we've received already, assume have everything we need and stop fetching
        break;
      }
      newIds.forEach(id => seenIDs.add(id));
      combinedEsriLayerJson.features = combinedEsriLayerJson.features.concat(newEsriLayerJson.features);
      exceededTransferLimit = newEsriLayerJson.exceededTransferLimit;
      if (exceededTransferLimit) {
        console.log("warning: exceeded transfer limit");
      }
    }
    return (_featureDataToGeoJson2 = featureDataToGeoJson(combinedEsriLayerJson)) !== null && _featureDataToGeoJson2 !== void 0 ? _featureDataToGeoJson2 : {
      type: "FeatureCollection",
      features: []
    };
  }
  get imageryProvider() {
    // Don't return an imagery provider if we haven't loaded metadata yet
    if (!this.strata.has(ArcGisFeatureServerStratum.stratumName)) {
      return undefined;
    }
    const {
      paintRules,
      labelRules
    } = tableStyleToProtomaps(this, false, true);
    const uri = this.buildEsriJsonUrl().logError("Failed to create valid FeatureServer URL");
    if (!uri) return;
    const url = proxyCatalogItemUrl(this, uri.toString());
    let provider = new ProtomapsImageryProvider({
      maximumZoom: this.getMaximumLevel(false),
      minimumZoom: this.getMinimumLevel(false),
      terria: this.terria,
      data: new ProtomapsArcGisPbfSource({
        url: url,
        outFields: [...this.outFields],
        featuresPerTileRequest: this.featuresPerTileRequest,
        maxRecordCountFactor: this.maxRecordCountFactor,
        maxTiledFeatures: this.maxTiledFeatures,
        tilingScheme: new WebMercatorTilingScheme(),
        enablePickFeatures: this.allowFeaturePicking,
        objectIdField: this.objectIdField,
        supportsQuantization: this.supportsQuantization
      }),
      id: this.uniqueId,
      paintRules,
      labelRules
    });
    provider = this.wrapImageryPickFeatures(provider);
    provider = this.updateRequestImage(provider);
    return provider;
  }
  get mapItems() {
    // If we aren't tiling requests, then we use GeoJsonMixin forceLoadGeojsonData
    if (!this.tileRequests) return super.mapItems;
    if (!this.imageryProvider) return [];
    return [{
      imageryProvider: this.imageryProvider,
      show: this.show,
      alpha: this.opacity,
      clippingRectangle: this.clipToRectangle ? this.cesiumRectangle : undefined
    }];
  }
  get dataColumnMajor() {
    if (super.dataColumnMajor.length > 0) {
      return super.dataColumnMajor;
    }
    // If we are tiling requests, then we don't have geojson/tabular data
    // We have to populate columns with empty strings, otherwise TableMixin.tableColumns will be empty.
    return this.columns.map(column => {
      var _column$name;
      return [(_column$name = column.name) !== null && _column$name !== void 0 ? _column$name : ""];
    });
  }

  /**
   * Constructs the url for a request to a feature server
   * @param resultOffset Allows for pagination of results.
   *  See https://developers.arcgis.com/rest/services-reference/enterprise/query-feature-service-layer-.htm
   */
  buildEsriJsonUrl(resultOffset) {
    const url = cleanUrl(this.url || "0d");
    const urlComponents = splitLayerIdFromPath(url);
    const layerId = urlComponents.layerId;
    if (!isDefined(layerId)) {
      return Result.error(networkRequestError({
        title: {
          key: "models.arcGisFeatureServerCatalogItem.invalidServiceTitle"
        },
        message: {
          key: "models.arcGisFeatureServerCatalogItem.invalidServiceMessage"
        }
      }));
    }

    // We used to make a call to a different ArcGIS API endpoint
    // (https://developers.arcgis.com/rest/services-reference/enterprise/query-feature-service-.htm) which took a
    // `layerdef` parameter, which is more or less equivalent to `where`. To avoid breaking old catalog items, we need
    // to use `layerDef` if `where` hasn't been set
    const where = this.where === "1=1" ? this.layerDef : this.where;
    const uri = new URI(url).segment("query").addQuery("f", "json").addQuery("where", where).addQuery("outFields", "*").addQuery("outSR", "4326");
    if (this.token) {
      uri.addQuery("token", this.token);
    }
    if (resultOffset !== undefined) {
      // Pagination specific parameters
      uri.addQuery("resultRecordCount", this.featuresPerRequest).addQuery("resultOffset", resultOffset);
    }
    return new Result(uri);
  }
}, _defineProperty(_ArcGisFeatureServerCatalogItem, "type", "esri-featureServer"), _ArcGisFeatureServerCatalogItem), _applyDecoratedDescriptor(_class.prototype, "imageryProvider", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "imageryProvider"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "mapItems", [override], Object.getOwnPropertyDescriptor(_class.prototype, "mapItems"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dataColumnMajor", [override], Object.getOwnPropertyDescriptor(_class.prototype, "dataColumnMajor"), _class.prototype), _class);
export { ArcGisFeatureServerCatalogItem as default };
function splitLayerIdFromPath(url) {
  const regex = /^(.*FeatureServer)\/(\d+)/;
  const matches = url.match(regex);
  if (isDefined(matches) && matches !== null && matches.length > 2) {
    return {
      layerId: matches[2],
      urlWithoutLayerId: matches[1]
    };
  }
  return {
    urlWithoutLayerId: url
  };
}
function cleanUrl(url) {
  // Strip off the search portion of the URL
  const uri = new URI(url);
  uri.search("");
  return uri.toString();
}